module.exports = __webpack_public_path__ + "img/1600.f7a57f65.gif";